import "./styles.scss";

export const MceCloseButton = ({ children, ...rest }) => {
  return (
    <button
      {...rest}
      id="mobile-not-allow-notifications-btn"
      className="mdn-Button mdn-Button--secondaryInverse mdn-Button--icon mdn-Button--md"
    >
      <em className="mdn-Icon-fechar mdn-Icon--sm"></em>
      <span>{children}</span>
    </button>
  );
};
